import { render, staticRenderFns } from "./JwJianzhuList.vue?vue&type=template&id=a43a7278"
import script from "./JwJianzhuList.vue?vue&type=script&lang=js"
export * from "./JwJianzhuList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports